import React, { useState, useEffect, useCallback } from "react";

//routes
import { useParams } from "react-router-dom";

//components
import DataTable from "../../../../components/Tables/DataTable";

//hooks
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useAuth from "../../../../hooks/useAuth";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import useMutationAuth from "../../../../hooks/useMutationAuth";
import { ClearOutlined as ClearOutlinedIcon } from "@mui/icons-material";
//graphql
import {
  DELETE_PROJECT_PERMISSIONS_LIST,
  GET_ALL_PROJECT_PERMISSIONS,
  ASSIGN_RESOURCES_TO_PROJECT,
  UPDATE_PROJECT_TIMESHEET_PERMISSION,
  UPDATE_PROJECT_PERMISSION_BY_LIST,
} from "../../../../graphql/projectPermission";

import { getDataTableData } from "./_table";

import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

//external components
import { CircularProgress, Grid, IconButton, Modal } from "@mui/material";

import ContainerCard from "../../../../components/Cards/ContainerCard";
import GridTable from "../../../../components/Tables/GridTable";

import EmployeesList from "../../Teams/Employees-list";

import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../../components/Modal/ConfirmationModal";
import CustomButton from "../../../../components/CustomButton";
import colors from "../../../../assets/theme/light/colors";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const ProjectPermission = ({ myCompany = false, fromTenant = false, projectGuid,  setDisplay = () => {}, fromResource=false }) => {
  const { pID } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const { storeUserGuid, userRoles } = useAuth();

  const { manageTimeEntry, manageUsers } = userRoles;

  const [re, setRe] = useState(false);
  const [data, setData] = useState(null);
  const [defaultFilters, setDefaultFilters] = useState({});
  const [columns, setColumns] = useState([]);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [search, setSearch] = useState("");
  const [resourceGuid, setResourceGuid] = useState([])
  const [openDialog, setOpenDialog] = useState(false);
  const [openApproverDialog, setOpenApproverDialog] = useState(false)
  const [isTimesheetApprover, setIsTimeSheetApprover] = useState(false)
  const [resourceApprovalInfo, setResourceApprovalInfo] = useState([]);


  useEffect(() => {
    const col = getDataTableData(t, updateApprovePermissionClick, updateManagePermissionClick,  manageTimeEntry === "R");
    if (col) {
      setColumns(col.columns);
      setOrderBy(col.defaultSort);
      setOrder(col.defaultSortDirection);
    }
  }, [columns?.length]);

  const { mfunction: getAllProjectPermissions, loading } = useLazyQueryAuth(
    GET_ALL_PROJECT_PERMISSIONS,
    "GetProjectPermissions"
  );

  const fetchTableData = useCallback(
    (page = 0, pageSize = 0, order = "", orderBy = "", search = "") => {
      getAllProjectPermissions(
        {
          variables: {
            model: {
              enableFilters: true,
              keys: {
                page: page + 1,
                pageSize: pageSize,
              },
              orderColumn: orderBy,
              orderDirection: order,
              keyword: search,
              userID: storeUserGuid,
              projectID: pID || projectGuid,
            },
          },
        },
        (response) => {
          setData(response);
        }
      );
    },
    []
  );

  useEffect(() => {
    if (columns.length > 0)
      fetchTableData(page, rowsPerPage, order, orderBy, search, defaultFilters);
  }, [columns.length, fetchTableData, re]);

  const rows =
    data &&
    data.GetProjectPermissions &&
    data.GetProjectPermissions.projectPermissionsList &&
    data.GetProjectPermissions.projectPermissionsList.projectPermissions
      ? data.GetProjectPermissions.projectPermissionsList.projectPermissions
      : [];
  const numberOfRecords =
    data &&
    data.GetProjectPermissions &&
    data.GetProjectPermissions.projectPermissionsList &&
    data.GetProjectPermissions.projectPermissionsList.totalNumberOfRecords
      ? data.GetProjectPermissions.projectPermissionsList.totalNumberOfRecords
      : 0;
  const { mfunction: deleteRecord, loading: deleteLoading } = useMutationAuth(
    DELETE_PROJECT_PERMISSIONS_LIST,
    "DeleteProjectPermissionsList"
  );

//   useEffect(() => {
//     if (selected.length > 0) {
//         const resourcesInfo = selected.map(selectedId => {
//             const matchingPermission = data.GetProjectPermissions.projectPermissionsList.projectPermissions.find(
//                 permission => permission.projectPermissionGuid === selectedId
//             );

//             if (matchingPermission) {
//                 return {
//                     resourceGuid: matchingPermission.resource.employeeGuid,
//                     isTimesheetApprover: matchingPermission.isTimesheetApprover,
//                     projectPermissionGuid: matchingPermission.projectPermissionGuid,
//                     userID: storeUserGuid,
//                     projectGuid: pID
//                 };
//             } else {
//                 return null;
//             }
//         }).filter(info => info !== null); // Filter out any undefined or null values

//         setResourceApprovalInfo(resourcesInfo);
//     }
// }, [selected]);

  const handleDelete = () => {
    deleteRecord(
      {
        variables: {
          model: {
            projectPermissionGuids: selected,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("projects.list.delete.success"), {
          variant: "success",
        });
        setRe((v) => !v);
        setSelected([]);
        setPage(0);
      }
    );
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const {
    mfunction: approveResourceRequest,
    loading: requestApprovalLoading,
  } = useMutationAuth(UPDATE_PROJECT_PERMISSION_BY_LIST, "UpdateProjectPermissionByList");
  const updateApprovePermissionClick = (row) => {
 

  const data={
    resourceGuid: row.resource.employeeGuid,
    isTimesheetApprover: !row.isTimesheetApprover,
    canManageTimeEntries: row.canManageTimeEntries,
    projectPermissionGuid: row.projectPermissionGuid,
    userID: storeUserGuid,
    projectGuid: pID||projectGuid
  }
  setResourceApprovalInfo([data])
//ApproveResourceTimesheet([data])
approveResourceRequest(
  {
    variables: {
      model: [data],
    },
  },
  (data) => {
    if (
      data["UpdateProjectPermissionByList"].errorCode !== null &&
      data["UpdateProjectPermissionByList"].errorCode !== ""
    ) {
      enqueueSnackbar(t(data["UpdateProjectPermissionByList"].errorMessage), {
        variant: "success",
        autoHideDuration: 5000
      });
    } else {
      enqueueSnackbar(t("assignResourcesToProject.success"), {
        variant: "success",
      });
      setSelected([]);
    //  setRe((val) => !val);
  row.isTimesheetApprover=!row.isTimesheetApprover

      handleClose();
      setDisplay(false);
    }
    setTimeout(() => {
    }, 500)
  },
  (error) => {
    enqueueSnackbar(t("systemError"), {
      variant: "error",
      autoHideDuration: 5000
    });
  }
);
  };
  const updateManagePermissionClick = (row) => {
    // Perform the required action when a row is clicked
    const data={
      resourceGuid: row.resource.employeeGuid,
      isTimesheetApprover: row.isTimesheetApprover,
      canManageTimeEntries:! row.canManageTimeEntries,
      projectPermissionGuid: row.projectPermissionGuid,
      userID: storeUserGuid,
      projectGuid: pID||projectGuid
    }
    setResourceApprovalInfo([data])
    //ApproveResourceTimesheet([data])
    approveResourceRequest(
      {
        variables: {
          model: [data],
        },
      },
      (data) => {
        if (
          data["UpdateProjectPermissionByList"].errorCode !== null &&
          data["UpdateProjectPermissionByList"].errorCode !== ""
        ) {
          enqueueSnackbar(t(data["UpdateProjectPermissionByList"].errorMessage), {
            variant: "success",
            autoHideDuration: 5000
          });
        } else {
          enqueueSnackbar(t("assignResourcesToProject.success"), {
            variant: "success",
          });
          setSelected([]);
        //  setRe((val) => !val);
      row.canManageTimeEntries=!row.canManageTimeEntries
    
          handleClose();
          setDisplay(false);
        }
        setTimeout(() => {
        }, 500)
      },
      (error) => {
        enqueueSnackbar(t("systemError"), {
          variant: "error",
          autoHideDuration: 5000
        });
      }
    );
  };
   const ApproveResourceTimesheet = (dataToSend) => {
   
  approveResourceRequest(
      {
        variables: {
          model: dataToSend,
        },
      },
      (data) => {
        if (
          data["UpdateProjectPermissionByList"].errorCode !== null &&
          data["UpdateProjectPermissionByList"].errorCode !== ""
        ) {
          enqueueSnackbar(t(data["UpdateProjectPermissionByList"].errorMessage), {
            variant: "success",
            autoHideDuration: 5000
          });
        } else {
          enqueueSnackbar(t("assignResourcesToProject.success"), {
            variant: "success",
          });
          setSelected([]);
        //  setRe((val) => !val);
          handleClose();
          setDisplay(false);
        }
        setTimeout(() => {
        }, 500)
      },
      (error) => {
        enqueueSnackbar(t("systemError"), {
          variant: "error",
          autoHideDuration: 5000
        });
      }
    );
  }
  
  const handleCloseApproval = () => {
    setIsTimeSheetApprover(false)
    setOpenApproverDialog(false)
  }

  const handleApproveSave = () => {
    ApproveResourceTimesheet()
    setOpenApproverDialog(false)
  }
  
  const customModalButtons = () => (
    <div>
      <CustomButton onClick={handleApproveSave} label={t("dialog.user.approve.yes")} />
    
        <CustomButton color={colors.error_light}  onClick={handleCloseApproval} label={t("dialog.user.approve.cancel")} />
      
    </div>
  );


  const {
    mfunction: assignResourcesToProject,
    loading: assignResourcesToProjectLoading,
  } = useMutationAuth(ASSIGN_RESOURCES_TO_PROJECT, "AssignResourcesToProject");

  const handleAddResource = (resourcesGUIDs) => {
    assignResourcesToProject(
      {
        variables: {
          model: {
            userID: storeUserGuid,
            resourcesIDs: resourcesGUIDs,
            projectGuid: pID,
          },
        },
      },
      (data) => {
        enqueueSnackbar(t("assignResourcesToProject.success"), {
          variant: "success",
        });
        setRe((val) => !val);
        handleClose();
        setDisplay(false)
      }
    );
  };

  const customButtons = [
    {
      label: "projectPermission.add.new.resource",
      handleClick: () => setOpenDialog(true),
      condition:
        (!selected || selected.length === 0) &&
        manageTimeEntry === "M" &&
        manageUsers === "M" && !fromResource,
      icon: true,
      iconButton: (
        <AddCircleRoundedIcon
          sx={{
            color: "var(--color--light-logo-blue)",
            fontSize: "28px !important",
          }}
        />
      ),
    },
    // {
    //   label: "projectPermission.make.resource.approver",
    //   handleClick: () => {setOpenApproverDialog(true); setIsTimeSheetApprover(true)},
    //   condition: selected.length > 0 && manageTimeEntry === "M" && manageUsers === "M" && !fromResource,
    //   icon: true,
    //   iconButton: (
    //     <ManageAccountsIcon
    //       sx={{
    //         color: "var(--color--light-logo-blue)",
    //         fontSize: "26px !important",
            
    //       }}
    //     />
    //   ),
    // },
  ];

  const pagination = {
    rows,
    columns,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    selected,
    setSelected,
    defaultFilters,
    setDefaultFilters,
    search,
    setSearch,
    setPage,
    setRowsPerPage,
    numberRecords: numberOfRecords,
    page,
    rowsPerPage,
    fetchTableData,
    loading: loading,
    searchText: "projectPermission.list.search.label",
    deleteText: "projectPermission.list.delete.label",
    handleDelete: handleDelete,
    deleteLoading,
    readOnly: manageTimeEntry !== "M",
    removeFilters: true,
    hideEditColumns: true,
    customButtons,
  };

  return (
    <div>
      <Modal
      open={openDialog}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      >
       <ContainerCard sx={{ padding: "10px 20px", width: "70%", maxHeight: "97vh" }}>
       <Grid container spacing={2}>
       <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "end",
            }}
          >
              <IconButton onClick={() => handleClose()}>
              <ClearOutlinedIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <EmployeesList
            projectGuid={pID}
            unassignedEmployees={false}
            pageSize={20}
            handleClick={handleAddResource}
            fromProjectPermission
          />
          </Grid>

       </Grid>
       </ContainerCard>
      </Modal>
      <ConfirmationModal
          contentText={
        t("dialog.user.make.approval.confirmation")
          }
          title={t("dialog.warning")}
          icon={"warning"}
          openDialog={openApproverDialog}
          handleClose={handleCloseApproval}
          customButtons={customModalButtons}
          t={t}
      />
      {loading && columns.length === 0 ? (
        <ContainerCard
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <CircularProgress />
        </ContainerCard>
      ) : (
        columns &&
        columns.length > 0 && (
          <DataTable
            {...pagination}
            identifier={"projectPermissionGuid"}
            hasCheckbox
          />
        )
      )}
    </div>
  );
};

export default ProjectPermission;
